/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */

import { Component } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { SaleDoc } from "../../../document/sale-document/sale-doc/sale-doc";
import { Zone } from "../../zone-settings/Zone";
import { StorePoliciesSettings } from "../store-policies-settings/StorePoliciesSettings";
import { StoreSettingsGenericComponent } from "../StoreSettingsGenericComponent";
import { Font_Size, Sort_Order, StoreSettingTapeReturnPrint } from "./store-setting-tape-return-print";
import { BusinessDetail } from "../../business-settings/business-detail/business-detail";

@Component({
  selector: "taku-tape-returnreceipt-builder",
  templateUrl: "tape-returnreceipt-builder.component.html",
  styleUrls: ["tape-returnreceipt-builder.component.scss"],
})
export class TapeReturnReceiptBuilderComponent extends StoreSettingsGenericComponent {
  lookup_font_size: any[];
  lookup_transaction_sorting: any[];

  previewSize = "NARROW";
  _pageTitlePrefix = "Return Tape Receipt";
  receiptDemoData: {
    saledoc: SaleDoc;
    policies: StorePoliciesSettings;
    businessDetail: BusinessDetail;
  };

  initLookups() {
    this.lookup_font_size = this.dbService.enumSelectOptions(Font_Size);
    this.lookup_transaction_sorting = this.dbService.enumSelectOptions(Sort_Order).map((item) => {
      if (item.value !== Sort_Order.Scan_Order && item.value !== null) {
        item.disabled = true;
        item.icon = "pi pi-lock";
      }

      return item;
    });
  }

  initValidation() {
    this._validation = {
      headerFontSize: Validators.required,
      lineFontSize: Validators.required,
      lineSortOrder: Validators.required,
    };
  }

  static init(fb: UntypedFormBuilder, zone: Zone): UntypedFormGroup {
    const tmpModel = new StoreSettingTapeReturnPrint(zone);
    const tmpForm = fb.group(tmpModel);

    return tmpForm;
  }

  initForm() {
    const activeZone = this.appSettingsService.getZone();
    this._model = "storeSettingTapeReturnPrint";
    this._object = new StoreSettingTapeReturnPrint(activeZone);
    this._myForm = TapeReturnReceiptBuilderComponent.init(this.fb, activeZone);
  }

  ngOnInit() {
    super.ngOnInit();

    this.subsList.push(
      this.printingFactoryService.createDemoData().subscribe((demoData) => {
        this.receiptDemoData = demoData;
      })
    );
  }
}

/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */
